// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608110322/js/" + chunkId + "." + {"44":"cd265556","225":"28c9cac6","481":"1184cd6e","486":"3a252e00","770":"305f7773"}[chunkId] + ".0.7284389396212315.chunk.js";
};